<template>
    <div class="main-content row mx-0">
        <div 
            class="col-12 col-sm-8 col-md-9"
            :class="{'pr-0' : $breakpoint.lgAndDown && !$breakpoint.xsOnly }"
        >
            <create-favourite-markets />
            <favourite-markets v-if="favCreated" class="mb-5" />
            <h1 class="heading-large first-header">
                <i class="fas fa-calendar-check mr-2"></i>Buying Report
            </h1>
            <volumes-per-product class="card" />
        </div>
        <div class="col-12 col-sm-4 col-md-3">
            <div class="d-flex justify-content-end">
                <refresh-information />
            </div>
            <h1 class="first-header heading-large">Tools</h1>
            <div class="tools">
                <market-change class="mb-5" />
                <dashboard-graphs class="mb-5" />
            </div>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import PageRefreshMixin from '@/mixins/PageRefreshMixin';
import DashboardGraphs from '@/components/Graphs/DashboardGraphs.vue'
import MarketChange from '@/components/Tools/MarketChange.vue'
import CreateFavouriteMarkets from "@/components/Wizard/CreateFavouriteMarkets.vue";
import FavouriteMarkets from "@/components/FavouriteMarkets.vue";
import VolumesPerProduct from '@/components/Graphs/VolumesPerProduct.vue';
import RefreshInformation from '@/components/RefreshInformation.vue';

const { detect } = require('detect-browser');

import { mapState, mapActions } from 'vuex';

export default {
    mixins: [breakpoint, PageRefreshMixin],
    components: {
        DashboardGraphs,
        MarketChange,
        CreateFavouriteMarkets,
        FavouriteMarkets,
        VolumesPerProduct,
        RefreshInformation
    },
    created: function(){
        this.fetchFavouriteMarkets();
        this.getLiveOffers();
        this.startPageRefresh(this.refreshPageData);
    },
    data(){
        return {
            browser: detect()
        }
    },
    computed: {
        ...mapState('login', ['userLoggedIn']),
        ...mapState("selectFavourites", ["favCreated", 'marketFavouritesList']),
        isGreenBsp() {
            return process.env.VUE_APP_Platform === "Greenergy";
        }
    },
    methods: {
        ...mapActions('selectFavourites', ['updateFavouritesMarkets', 'favouritesCreated', 'selectFavouriteOption']),
        ...mapActions('offers', ['getLiveOffers']),
        fetchFavouriteMarkets: async function(){
            const response = await this.axios.get('/api/getFavourites', {params: {
                userId: this.userLoggedIn.userId, 
                key: 'FAVOURITE_MARKETS'
            }})

            if (response.data.success){
                this.updateFavouritesMarkets(response.data.payload.favouriteMarkets)

                /* If there is at least one favourite market found, select the first one and display the markets */
                if (response.data.payload.favouriteMarkets.length > 0){
                    this.favouritesCreated()
                    this.selectFavouriteOption({key: 0, serviceName: this.marketFavouritesList[0].type})
                }
            }
        },
        refreshPageData() {
            this.getLiveOffers();
        }
    }
}
</script>
